import React from "react";
import { useNavigate } from "react-router-dom";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const PropertyCard = ({ property, type }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    if (property?.slug) {
      const base = type === "apartment" ? "/apartmani" : "/sobe";
      navigate(`${base}/${property.slug}`);
      return;
    }
    if (property?.link) {
      navigate(property.link);
      return;
    }

    navigate("/");
  };

  const displayTitle = property?.title || "";

  return (
    <div className="bg-card rounded-xl shadow-subtle hover:shadow-medium transition-smooth overflow-hidden group">
      {/* Image */}
      <div
        className="relative h-56 sm:h-64 md:h-72 overflow-hidden cursor-pointer"
        onClick={handleViewDetails}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleViewDetails();
        }}
      >
        <Image
          src={property?.image}
          alt={displayTitle}
          className="w-full h-full object-cover object-[50%_40%] transition-smooth"
        />
        {property?.status && (
          <div className="absolute top-4 left-4">
            <span className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-medium">
              {property.status}
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-3 gap-2">
          <h3 className="font-heading text-xl font-semibold text-foreground group-hover:text-primary transition-smooth">
            {displayTitle}
          </h3>
          <div className="text-right">
            {property?.price != null && (
              <>
                <p className="font-heading text-lg font-bold text-primary">
                  €{property.price}
                </p>
                <p className="text-xs text-muted-foreground">per night</p>
              </>
            )}
          </div>
        </div>

        {property?.description && (
          <p className="text-muted-foreground text-sm mb-4 line-clamp-2">
            {property.description}
          </p>
        )}

        {/* Amenities */}
        {!!property?.amenities?.length && (
          <div className="flex flex-wrap gap-3 mb-6">
            {property.amenities.map((amenity, index) => (
              <div
                key={index}
                className="flex items-center space-x-1 text-xs text-muted-foreground"
              >
                <Icon name={amenity?.icon} size={14} />
                <span>{amenity?.label}</span>
              </div>
            ))}
          </div>
        )}

        {/* Stats */}
        <div className="flex items-center justify-between mb-6 text-sm text-muted-foreground">
          {property?.capacity && (
            <div className="flex items-center space-x-1">
              <Icon name="Users" size={14} />
              <span>{property.capacity} guests</span>
            </div>
          )}
          {property?.location && (
            <div className="flex items-center space-x-1">
              <Icon name="MapPin" size={14} />
              <span>{property.location}</span>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="flex space-x-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handleViewDetails}
            className="flex-1"
            iconName="Eye"
            iconPosition="left"
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;
